import { render, staticRenderFns } from "./progress-history.vue?vue&type=template&id=0051a28c&"
import script from "./progress-history.vue?vue&type=script&lang=js&"
export * from "./progress-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports